import { appVersion as appVersionApi } from '../../../api/app_version';
import { getVersion, clearCacheData } from '../../../util/tools';

export const appVersionAction = () => async () => {
  let response = await appVersionApi({ vAppType: 'Operator' });
  if (response.status && response.data.length !== 0) {
    const serverVersion = response.data[0].vAppVersion;
    const appVersion = getVersion();
    console.log('Server Version : ', serverVersion);
    console.log('App Version : ', appVersion);
    const checkVersion = serverVersion === appVersion;
    if (!checkVersion) {
      clearCacheData();
    }
  }
};
